import { useState } from 'react';

export const useAccountApplicationsSearch = () => {
    const [keyword, setKeyword] = useState('');

    const handleFilterByKeyword = (newKeyword: string) => {
        setKeyword(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
